import Keycloak from 'keycloak-js';
import Roles from '../types/Roles';
// import LogRocket from 'logrocket';

const kc = Keycloak({
    realm: 'drugdev',
    url: process.env.AUTHENTICATION_SERVICE_URL,
    'ssl-required': 'external',
    resource: 'sparksafety',
    'public-client': true,
    clientId: 'sparksafety'
});

const authentication = {
    initialize: (success, fail) => {
        return new Promise((resolve, reject) => {
            kc
                .init({ onLoad: 'check-sso' })
                .success(authenticated => {
                    authenticated ? resolve() : kc.login();
                })
                .error(kc.login);
        });
    },
    refreshToken: (minValidity = 5) => {
        return new Promise((resolve, reject) => {
            kc
                .updateToken(minValidity)
                .success(resolve)
                .error(kc.login);
        });
    },
    loadUserInfo: () => {
        return new Promise((resolve, reject) => {
            kc
                .loadUserInfo()
                .success(userInfo => {
                    resolve({
                        ...userInfo,
                        isEnterpriseAdmin: kc.hasRealmRole(Roles.ENTERPRISE_ADMIN)
                    });
                })
                .error(reject);
        });
    },
    redirectToLogin: () => kc.login(),
    logout: () => kc.logout(),
    getToken: () => kc.token
};

export default authentication;
